import 'regenerator-runtime/runtime';
import { call, select, takeEvery } from 'redux-saga/effects';
import {
  AvUpdateRequestModel,
  PollingCreatedResponseModel,
  PollingResponseModel,
  UpdateAvRequestModelForCap,
} from '@ps20/bff-models';
import { App } from '@ps20-frontend/frontend-models';
import {
  DoRequestResponse,
  getEndpointUrl,
  GlobalActions,
  GlobalPut,
} from '@ps20-frontend/shop-integration-redux';
import { BeforeUnloadEventHandler } from '@ps20-frontend/shop-integration';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { PS20Logger } from '@ps20-frontend/logging';
import { CheckoutAction, CheckoutActions } from '../checkout.actions';
import { IAppState } from '../localStore';
import { shouldUseSdwEndpoint } from '../selector/transient-state.selector';
import { antragEinreichen } from './antragEinreichenSaga';
import { startPolling } from './pollingHelper/pollingHelper';
import { handlePollingError } from './pollingHelper/pollingErrorHandler';
import { CAP_UPLOAD_EVENTS } from './pollingHelper/polling-events';

export function* watchCapStart() {
  yield takeEvery(
    CheckoutActions.CAP_ANTRAG_EINREICHEN,
    safeSaga(capGetSpeicherdaten, App.SHOP_CHECKOUT),
  );
  yield takeEvery(
    GlobalActions.SPEICHERDATEN_GENERATED_CAP,
    safeSaga(capInitialRequest, App.SHOP_CHECKOUT),
  );
  yield takeEvery(
    CAP_UPLOAD_EVENTS.START_POLLING,
    safeSaga(capUploadStartPolling, App.SHOP_CHECKOUT),
  );
  yield takeEvery(
    CAP_UPLOAD_EVENTS.UPLOAD_SUCCESSFUL,
    safeSaga(successCallback, App.SHOP_CHECKOUT),
  );

  yield takeEvery(CAP_UPLOAD_EVENTS.UPLOAD_ERROR, safeSaga(handlePollingError, App.SHOP_CHECKOUT));
}

export function* capGetSpeicherdaten() {
  const globalPut = GlobalPut.getInstance();

  yield call([globalPut, globalPut.put], new GlobalActions().speicherdatenRequestedCap());
}

export function* capInitialRequest(action: CheckoutAction<AvUpdateRequestModel>) {
  const state: IAppState = yield select();
  const avUpdate: UpdateAvRequestModelForCap = action.payload;
  try {
    yield call(
      antragEinreichen,
      {
        url: getEndpointUrl(shouldUseSdwEndpoint(state), '/privatschutz/api/cap/upload/async'),
        successEvent: CAP_UPLOAD_EVENTS.START_POLLING,
        errorEvent: CAP_UPLOAD_EVENTS.UPLOAD_ERROR,
        noCache: true,
      },
      null,
      avUpdate,
    );
  } catch (e) {
    PS20Logger.error(App.SHOP_CHECKOUT, e as Error, 'cap/upload/async request failed');
  }
}

export function* capUploadStartPolling(action: DoRequestResponse<PollingCreatedResponseModel>) {
  const state: IAppState = yield select();
  yield call(startPolling, {
    pollingUrl: getEndpointUrl(
      shouldUseSdwEndpoint(state),
      `/privatschutz/api/cap/upload/poll?pollingId=${action.payload.id}`,
    ),
    successEvent: CAP_UPLOAD_EVENTS.UPLOAD_SUCCESSFUL,
    errorEvent: CAP_UPLOAD_EVENTS.UPLOAD_ERROR,
  });
}

export const successCallback = function* (
  successAction: CheckoutAction<PollingResponseModel<string>>,
) {
  BeforeUnloadEventHandler.remove();
  yield call(navigateToUrl, successAction.payload.response);
};

/* istanbul ignore next */
export const navigateToUrl = (url: string) => {
  window.location.href = url;
};
